export const masacAddress = str => str.substring(0, 4) + '...' + str.substr(-4)
export function numberWithCommas(x, len = 2) {
  if(x > 1000) return Number(x).toFixed(len).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return Number(x).toFixed(2)
}


export const formatTime = (time) => {
  const addZero = (num) => (num < 10 ? `0${num}` : num);

  const hours = addZero(Math.floor(time / (60 * 60 * 1000)));
  const minutes = addZero(Math.floor((time % (60 * 60 * 1000)) / (60 * 1000)));
  const seconds = addZero(Math.floor((time % (60 * 1000)) / 1000));
  const milliseconds = addZero(Math.floor((time % 1000) / 10))
  
  return `${hours}:${minutes}:${seconds}:${milliseconds}`;
};



export const toFixed = x => {  
  if(x == 0){
    return '0.00'
  }

  if (Math.abs(x) < 1.0) {
    var e = parseInt(x.toString().split('e-')[1]);
    if (e) {
        x *= Math.pow(10,e-1);
        x = '0.' + (new Array(e)).join('0') + x.toString().substring(2);
    }else{
      let str = x.toString().split('.')[1];
      let match = str.match(/[1-9]/);
      if (match) {
        let index = match.index;
        let str = x.toString().slice(index + 2 , index + 5)
        const strFormat = `0.${Array(index).fill(0).join('')}${str}`
        return strFormat
      } else {
        
      }
    }
    
  } else {
    var e = parseInt(x.toString().split('+')[1]);    
    if (e > 20) {
        e -= 20;
        x /= Math.pow(10,e);
        x += (new Array(e+1)).join('0');
    }else{
      return (+x).toFixed(3)
    }
  }
  return x;
}

export const whiteList = [
  '0x3a121Fb7CA135Ea7b7029d5dc2198c90f005C60c',
  '0x5c246808E34629098651793d3fB79f413Cb67425',
  '0xb8E9f05beA1d82e1E4Aa79DD60D9065d1Bc0cAcC',
  '0xC6eDc770fcaf2d80506A7ba96354d2DFAdEb6D0F',
  '0x72C9e6cB9BCD28d65c71e61f72Bee1790b567127',
  '0x2f75442ebe16D80C7A4f642862E3B3CEe47E5B54',
  '0x047AE38BEC9Cd1e36Ce664b953D1a71e6c29f195',
  '0xb8f186Ea08b8Fe0Dd4d46EB6103093e107C11555',
  '0xC0e450341f6339e6584BCdD237b5b6535F9785E9',
  '0x5e729af81e88a21895ac83400adDd2F2078c6A00',
  '0x570F9a34c2201283D21fDA5AF074B413Fe12069A',
  '0x61E5ab355B98ED4055282C1AC5d5cF738BCdd630',
  '0x7A34E75dc07d917CfeFA65D9BCfCAf2B25C52380',
  '0x7Fa6eD463c00A8e3772B8279feAD0de287cb972c',
  '0x2b21e04509583eBbf2D7fFBE013F6cba6b6ba605',
  '0x8371ddeBeCD729Bfb14e4aB7D4aB2bAaDF79A4BF',
  '0x99095B01f51c73b143b487669488E220Fc16EA44',
  '0x3af6eE1834eBB7e3ff368Ebb33d087F5CCe878D8',
  '0x6591C24a7f7d3B37527487a457b2f467936DFE59',
  '0x443cc1CeF791BC08791a06dE35fC551c13cAD50d',
  '0x4CACB9a2065bE7bbFF87Ce9e8ee65A8CEC0D3593',
  '0x4a7f1Df9b2C3801198AC7c28c93a4273b821D2d0',
  '0x61aE6Ce1F83b79CA28dbfA732f41811d63E95966',
  '0x912F718466A190E0511e86F56CC6CD889f912a4C',
  '0xd50d47F0ae102aD9F6Aa18f187a6cAD3DC42AFc9',
  '0xe88c24b71d8463E4c84f63155F2477Ebcd0F65BF',
  '0xF7A819DEBA0d69C4f3567cb9fAc04B05Ec3A6516',
  '0xE0D3dC4Ad4d4974084BcC108Eb4292D6113EdC45',
  '0x8221F1AD11011EfB5A61b674756193B455ffd87D',
  '0x517b5082f6e13d9aecc1791ccb0cb58b2484a8a0',
  '0xCD31BA0842B9FDd628CA334ABAF0Cb03ec01d333',
  '0x3e698f0Dbe28a74dBdBC451cF9D0EDdEe862d734',
  
  '0x299667e0B886bc54b74C6229730c2AA6082c9AF3',
  '0x432d5a60721337e67f67f5d198D9585Cf995419f',
  '0x3F16324623eAe60271f624D7c16637Ea9ac08b4B',
  '0xF1fdAa157a9C7943692171c95B8F73C8c2Fd655F',
  '0xCE4Dfb3A4E053dcbb931f5ED5fB15F1E07955f9b',
  '0x99095B01f51c73b143b487669488E220Fc16EA44',
  '0x382827268EfD1a65e391F058CdcA9c082A3B9Df2',
  '0x6867B29F8AF0674b660E210Db55752D53aBF05B7',
  '0x00000034052862A6F264cFA365191822aBE146Fd',
  '0xAB5971dDA9F26c88Ff357c60Fce2e2270AA47857',
  '0xF75bcFA2c0361C5589D671FD9490Ca83EF829cd9',
  '0x299f3e6838d493Be30CAa0a42b82402B2118A4f9',
  '0x42c83e3B740c077488A03717A1c12a9C4d786357',
  '0x71E89867d5Ae324e2848e7e53578f407b1e7A65e',
  '0x3510Dd722560F6EdF37F252F5A151E4cE0b45622',
  '0xF1F1B08DbE82398352C22A0Effc2c713dD566EDd',

  '0x447Ed7a3e5b4E5096FD81E10eC6DF5F8cdA5bA60',
  '0x68Ea25e8eb56132b6E1381E96441Ad3982d5c9D0',
  '0xd13F886325639372a83ece4936654592d79056f7',

]